import { RouterProvider } from "react-router-dom";

import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/global/AuthContext";
import { LanguageSync } from "@/global/LanguageSync";
import { TenantGuard } from "@/global/TenantGuard";

import router from "./routes";

function App() {
  return (
    <TenantGuard>
      <AuthProvider>
        <LanguageSync />
        <RouterProvider router={router} />
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </TenantGuard>
  );
}

export default App;
